var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      staticClass: "loader",
      attrs: {
        width: "38px",
        height: "38px",
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        staticClass: "loader__circle",
        attrs: {
          stroke: _vm.$props.color,
          "stroke-width": "8",
          cx: "19",
          cy: "19",
          r: "14",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }